import React, { useState } from 'react';
import classes from './ChatLauncher.module.scss';
import Avatar from '../Avatar/Avatar';
import MuiPlaceholder from '../controls/MuiPlaceholder/MuiPlaceholder';
import { useDispatch, useSelector } from 'react-redux';
import type { RootState } from '../../types/redux';
import { 
  setWidgetIsOpen, 
  setPrechatEnabled, 
  setPrechatFormOpened, 
  setAvatarUrl 
} from '../../store/actions/general';
import { getUiConfig, getComponentsConfig } from '../../utils/config';

const ChatLauncher = () => {
  const dispatch = useDispatch();
  const { widgetIsOpen, prechatFormOpened, muiFontLoaded } = useSelector((state: RootState) => state.general);
  const [ helpTextOpen, setHelpTextOpen ] = useState(true);
  const isUrl = (str) => {
    try {
      new URL(str);
      return true;
    } catch (error) {
      return false;
    }
  }

  const uiConfig = getUiConfig();

  const returnAvatar = () => {
    const launcherIcon = uiConfig?.launcher_icon;
    if (launcherIcon === 'avatar') {
      return uiConfig?.avatar_url ?? false
    } else if (isUrl(launcherIcon)) {
      return launcherIcon
    }

    return false
  }
  const avatar = returnAvatar();
  const chatLauncherClasses = avatar === false ? [classes.ChatLauncher] : [classes.ChatLauncherAvatar];

  if (widgetIsOpen) {
    chatLauncherClasses.push('invisible');
  }

  const openWidget = () => {
    const components = getComponentsConfig();
    dispatch(setPrechatEnabled(components["prechat"]["enabled"]));
    dispatch(setPrechatFormOpened(prechatFormOpened));
    dispatch(setAvatarUrl(uiConfig?.avatar_url ?? ''));
    dispatch(setWidgetIsOpen(true));
  };

  const launcherHelpText = (() => {
    return (!uiConfig?.launcher_help_text) ? '' : uiConfig.launcher_help_text;
  })();

  return (
    <div className={classes.ChatLauncherContainer}>
      {launcherHelpText !== '' && helpTextOpen ? (
        <div className={classes.ChatLauncherMessage}>
          <button className={classes.IconButton} onClick={()=> setHelpTextOpen(false)}>
            <MuiPlaceholder
              isMuiFontLoaded={muiFontLoaded}
              element={<div>close</div>}
              width={80}
              height={80}
              backgroundColor={'transparent'} />
          </button>
          <div style={{ fontFamily: uiConfig?.incoming_messages?.font_family ?? undefined }}>{launcherHelpText}</div>
        </div>
      ) : (<div/>)}
        <div
        className={chatLauncherClasses.join(' ')}
        onClick={openWidget}
        style={{
          width: uiConfig?.launcher_size ?? 40,
          height: uiConfig?.launcher_size ?? 40
        }}
      >
        {avatar !== false ? (
          <Avatar
            pictureUrl={avatar}
            height={uiConfig?.launcher_size ?? 40}
            width={uiConfig?.launcher_size ?? 40}
            borderRadius = "100%"
            backgroundSize = "80px 80px"
            backgroundRepeat = "no-repeat"
            backgroundColor = "#00263E"
            backgroundPositionX = "0"
          />
        ) : (
          <div 
            className={classes.Icon}
            style={{
              fontSize: (uiConfig?.launcher_size ?? 40) * 0.7
            }}
            >
              {uiConfig?.launcher_icon}
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatLauncher;
